var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "mini-topbar d-flex" },
      [
        _c(
          "v-avatar",
          {
            staticClass: "pa-2 mr-auto",
            staticStyle: { left: "20px" },
            attrs: {
              tile: "",
              "min-width": "55",
              width: this.$vuetify.breakpoint.width >= 996 ? 100 : 80,
              "max-width": "100",
              height: "48",
            },
          },
          [
            _c("v-img", {
              attrs: {
                contain: "",
                src: require("@/assets/logos/full_logo_horizontal_dark.svg"),
              },
            }),
          ],
          1
        ),
        _vm._m(0),
        _c(
          "div",
          {
            staticClass:
              "ml-auto height-100x justify-center align-center d-flex",
            staticStyle: { "margin-right": "28px", gap: "8px" },
            attrs: { id: "appbarLangMenu" },
          },
          [
            _c(
              "v-btn",
              {
                staticClass: "py-3",
                attrs: { color: "white", outlined: "", "x-small": "" },
                on: { click: _vm.UserLogout },
              },
              [
                _c("v-icon", { attrs: { left: "", small: "" } }, [
                  _vm._v("mdi-logout"),
                ]),
                _vm._v(" Logout "),
              ],
              1
            ),
            _c(
              "v-menu",
              {
                attrs: {
                  center: "",
                  left: "",
                  origin: "center center",
                  transition: "slide-y-reverse-transition",
                  attach: "#appbarLangMenu",
                  "offset-overflow": "",
                  "nudge-left": "40",
                  "min-width": "140",
                  "close-on-content-click": false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "div",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass:
                                  "cursor-pointer d-flex align-center",
                              },
                              "div",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "py-3",
                                attrs: {
                                  color: "white",
                                  outlined: "",
                                  "x-small": "",
                                },
                              },
                              [_vm._v(_vm._s(_vm.getLocale))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.langMenu,
                  callback: function ($$v) {
                    _vm.langMenu = $$v
                  },
                  expression: "langMenu",
                },
              },
              [
                _c(
                  "v-list",
                  { attrs: { dense: "", nav: "", width: "150" } },
                  [
                    _c(
                      "v-list-item",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.langClick("en")
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "cursor-pointer" },
                          [_vm._v(" EN ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.langClick("ko")
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "cursor-pointer" },
                          [_vm._v(" KO ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "mx-auto d-flex justify-center align-center" },
      [
        _c("h1", { staticClass: "text-h6 white--text" }, [
          _vm._v("FOEx Suite Admin Dashboard"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }